import apiClient from "../config/apiClient";
import { API_ENDPOINTS } from "../config/endpoints";
import { handleApiError } from "../config/errorHandler";

/**
 * Add Item to Cart API Call
 * @param {Object} cartData - Cart item details
 * @returns {Promise<Object>} - Response data from the API
 */
export const addToCart = async (cartData) => {
  try {
    const response = await apiClient.post(API_ENDPOINTS.ADD_TO_CART, cartData);
    return response.data.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
